import { usePreferences } from '@atom/hooks/usePreferences';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import { useChatUI } from './hooks/useChatUI';
import Chat from './Chat';

import classes from './chat.module.css';

const ChatSidebar = () => {
  const preferences = usePreferences();
  const { chatOpen, chatExpanded } = useChatUI();
  const isAiEnabled = !!preferences?.ai?.enabled;
  const aiRoleSet = preferences?.ai?.roleSet;
  const hasPermission = aiRoleSet && hasRolePermissions(ROLE_SETS[aiRoleSet]);
  const showAi = isAiEnabled && hasPermission;

  if (!chatOpen || !showAi) {
    return null;
  }

  return (
    <>
      <div
        className={
          chatExpanded ? classes.chatBackdropFullscreen : classes.chatBackdrop
        }
      />
      <div
        className={
          chatExpanded
            ? classes.chatSidebarFullscreen
            : classes.chatSidebarOverlay
        }
      >
        <Chat />
      </div>
    </>
  );
};

export default ChatSidebar;
